






















import Vue, {VueConstructor} from 'vue'
import dynPlaceholder from '../dynPlaceholder.vue'

export default (Vue as VueConstructor<Vue & {
  $refs: {
    textarea: HTMLElement
  }
}>).extend({
  components: {dynPlaceholder},
  name: 'UiTextareaInput',
  props: {
    name: {},
    value: String,
    placeholder: {},
    readOnly: {type: Boolean, default: false},
    required: {type: Boolean, default: false},
    type: String,
    rows: {
      type: Number,
      default: 1
    },
    maxRows: {
      type: Number,
      default: 4
    },
    error: Boolean,
    hideDynPlaceholder: Boolean,
    disabled: Boolean
  },
  data () {
    return {
      focused: false,
      minHeight: 0,
      maxHeight: 0
    }
  },
  methods: {
    onBlur (event: UIEvent) {
      this.$emit('blur', event)
      this.focused = false;
    },
    onInput (event: any) {
      this.$emit('input', event.target.value)
    },
    setInputHeight () {
      this.$refs.textarea.style.height = '5px';
      this.$refs.textarea.style.height = (this.$refs.textarea.scrollHeight) + 'px';
    },
    onFocus (event: UIEvent) {
      this.focused = true;
      this.$emit('focus', event)
    }
  },
  computed: {
    currentValue: {
      get (): string {
        return this.value || ''
      },
      set () {
      }
    }
  },
  mounted () {
    this.$nextTick(() => {
      this.minHeight = this.$refs.textarea.scrollHeight
      this.maxHeight = (this.$refs.textarea.scrollHeight - 10) * this.maxRows
    });
  },
  watch: {
    value (val) {
      this.$nextTick(() => {
        this.setInputHeight();
      });
    }
  }
})
